import React from "react";
import { RaisedButton } from "material-ui";

const STRIPE_CLIENT_ID = "ca_AHfHQUGIyItyiVL4ASn0ERsD9Gre45g1";
const STRIPE_REDIRECT_URL = "https://dashboard.chowreach.com/connect";

export default ({ restaurantId }) => {
  const linkUrl = `https://connect.stripe.com/oauth/authorize?state=${restaurantId}&client_id=${STRIPE_CLIENT_ID}&redirect_uri=${STRIPE_REDIRECT_URL}&scope=read_write&response_type=code`;
  const _linkToStripe = () => {
    window.location.href = linkUrl;
  };
  return (
    <div>
      <h3>Connect with Stripe</h3>
      <p>
        Link your Chowreach account with Stripe to enable online ordering. We
        use Stripe to securely handle credit card payments and to automate the
        payout process.
      </p>
      <p>
        Stripe will charge you the standard credit card rate of 2.9% + 30c per
        transaction.
      </p>
      <RaisedButton
        onTouchTap={_linkToStripe}
        label="Link with Stripe"
        primary={true}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LinkWithStripe.js